import { UserRoles, SideBarItems } from "@/types";
import { Routes } from "@/router/routes";
import { v4 as uid } from "uuid";
import { camelCase } from "lodash";

export function getSessionId() {
  let value = window.sessionStorage.getItem("sessionId");
  if (!value || !window.name) {
    value = uid();
    window.sessionStorage.setItem("sessionId", value);
  }
  window.name = value;
  return value;
}

export function createSideBar(
  roles: UserRoles = [],
  access: any
): SideBarItems {
  const items = {
    dashboardHome: {
      icon: "mdi-view-dashboard",
      text: "Dashboard",
      routeName: Routes.DashBoard
    },
    verification: {
      icon: "mdi-shield-check",
      text: "Verification",
      routeName: Routes.Verification
    },
    doctorNominations: {
      icon: "mdi-doctor",
      text: "Nominations",
      routeName: Routes.DoctorNominations
    },
    callHistory: {
      icon: "mdi-phone-log",
      text: "Call history",
      routeName: Routes.CallHistory
    },
    commissions: {
      icon: "mdi-account-cash",
      text: "Commissions",
      routeName: Routes.Commissions
    },
    leads: {
      icon: "mdi-account-heart",
      text: "Leads",
      routeName: Routes.Leads
    },
    leadSources: {
      icon: "mdi-account-group",
      text: "Lead Sources",
      routeName: Routes.LeadSources
    },
    agents: {
      icon: "mdi-face-agent",
      text: "Agents",
      routeName: Routes.Agents
    },
    dids: {
      icon: "mdi-folder-pound-outline",
      text: "DIDs",
      routeName: Routes.DIDs
    },
    onHold: {
      icon: "mdi-phone-log",
      text: "On Hold",
      routeName: Routes.OnHold
    },
    postDates: {
      icon: "mdi-calendar-range",
      text: "Post Dates",
      routeName: Routes.PostDates
    },
    settings: {
      icon: "mdi-cog",
      text: "Settings",
      routeName: Routes.Settings
    }
  };

  if (roles.includes("admin")) {
    return Object.values(items);
  }

  if (access && access.featureAccess) {
    let allowedItems: any[] = [items.dashboardHome];
    Object.keys(access.featureAccess).forEach(feature => {
      const feat = camelCase(feature);
      if (items.hasOwnProperty(feat)) {
        // @ts-ignore
        allowedItems.push(items[feat]);
      }
    });

    return allowedItems;
  }

  return [items.dashboardHome];
}
